import { Flex, Spin } from "antd";
import { SmallTitle } from "components/Common/Typography/Titles";
import { SvgIcons } from "Icon/SvgIcons";
import React, { useEffect, useState } from "react";
import FileProperty from "./FileProperty";

interface UploadedFilesProps {
  candidateNotes: any; // Replace `any` with proper typing if available
}

interface FileData {
  name: string;
  size: number;
  url: string;
}

const UploadedFiles: React.FC<UploadedFilesProps> = ({ candidateNotes }) => {
  const [pdfFiles, setPdfFiles] = useState<FileData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getFileNameFromUrl = (url: string): string | null => {
    if (!url) return null;
    try {
      const pathname = new URL(url).pathname;
      return pathname.substring(pathname.lastIndexOf("/") + 1);
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchFileDetails = async () => {
      if (!candidateNotes || !Array.isArray(candidateNotes)) return;

      setLoading(true);

      const files = await Promise.all(
        candidateNotes
          .filter((note: any) => !!note.resume_pdf)
          .map(async (note: any) => {
            const url = note.resume_pdf;

            return { name: note.resume_name, size: 0, url };
          })
      );

      setPdfFiles(files);
      setLoading(false);
    };

    fetchFileDetails();
  }, [candidateNotes]);

  if (loading) {
    return (
      <Flex justify="center" align="center" className="h-6 mt-3 p-[6px]">
        <Spin tip="Loading files..." size="small" />
      </Flex>
    );
  }

  if (!pdfFiles.length) return null;

  return (
    <Flex className="mt-3 p-[6px]" vertical gap={20}>
      <Flex justify="space-between" align="center" className="py-[6px]">
        <div className="font-bold pr-2.5 text-sm">Uploaded Files</div>
      </Flex>
      <Flex gap={6} align="center" className="flex-wrap">
        {pdfFiles.map((file, index) => (
          <FileProperty
            key={index}
            name={file.name ? file.name : getFileNameFromUrl(file.url)}
            size={file.size}
            url={file.url}
          />
        ))}
      </Flex>
    </Flex>
  );
};

export default UploadedFiles;
